import React, { useState, useRef, useCallback, useEffect } from 'react';
import MapWithOpenLayers from './MapWithOpenLayers';

const SingleCard = ({ image, name, role, company, sector, location, id, onMore, extra, isMobile }) => {
  const handleClick = () => {
    if (onMore) onMore();
  };



  return (
          <div
        style={{
          background: '#ffffff',
          borderRadius: isMobile ? '15px' : '20px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
          overflow: 'hidden',
          width: '100%',
          height: isMobile ? '260px' : '280px',
          minHeight: isMobile ? '260px' : '280px',
          margin: 'auto',
          display: 'flex',
          flexDirection: 'column',
          transition: 'box-shadow 0.2s',
          cursor: 'pointer',
          position: 'relative',

        }}
    >
      <div onClick={handleClick} style={{ 
        width: '100%', 
        height: isMobile ? 120 : 140,
        overflow: 'hidden', 
        background: '#f3f3f3',
        flexShrink: 0
      }}>
        <img 
          src={image} 
          alt={name} 
          style={{ 
            width: '100%', 
            height: '100%', 
            objectFit: 'cover'
          }}
        />

      </div>
      <div style={{ 
        padding: isMobile ? '12px 10px 10px 10px' : '14px 12px 12px 12px', 
        width: '100%', 
        textAlign: 'center',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}>
        <div>
          <h3 style={{ margin: 0, fontWeight: 700, fontSize: isMobile ? 16 : 18, color: '#333333' }}>{name}</h3>
          {name === 'Gunzert House' ? (
            <>
              {sector && (
                <span style={{
                  display: 'inline-block',
                  background: '#e0f7fa',
                  color: '#00796b',
                  borderRadius: '12px',
                  padding: '4px 12px',
                  fontSize: 12,
                  fontWeight: 600,
                  marginBottom: 4,
                }}>{sector}</span>
              )}
            </>
          ) : (
            <>
                             <div style={{ fontSize: 13, color: '#666666', margin: '4px 0 8px 0' }}>{role}</div>
              {sector && (
                <span style={{
                  display: 'inline-block',
                  background: '#e0f7fa',
                  color: '#00796b',
                  borderRadius: '12px',
                  padding: '4px 12px',
                  fontSize: 12,
                  fontWeight: 600,
                  marginBottom: 4,
                }}>{sector}</span>
              )}
                               {location && (
                   <div style={{ fontSize: 12, color: '#666666', marginTop: 4 }}>{location}</div>
                 )}
            </>
          )}
        </div>
        <div style={{ marginTop: 'auto' }}>
                     <button onClick={onMore} style={{ 
             background: '#FF6347', 
             color: 'white', 
             border: 'none', 
             cursor: 'pointer', 
             fontWeight: 600, 
             fontSize: isMobile ? 12 : 14, 
             padding: isMobile ? '6px 12px' : '8px 16px',
             borderRadius: '8px',
             transition: 'all 0.2s ease'
           }}>More</button>
        </div>
      </div>
    </div>
  );
};

const Space = () => {


  const [founders] = useState([
    // NOTE: For brevity, only a subset is shown here. Add the remaining
    // entries from your dataset below in the same shape.
    {
      id: 1,
      name: 'SmartPark-Innovation',
      company: 'ICT',
      description: 'TechTrain Academy is a premier training and consulting institution',
      image: '/assest/img/master12.jpg',
      lat: -6.369028,
      lng: 35.748519,
      extra: {
        contactName: 'Eng. Vedasto Biyaka',
        contactEmail: 'vedasto.biyaka@katubuka.com',
        phoneNumber: '0716893830',
        spaceType: 'Incubator',
        spaceTypeOther: 'incubator',
        yearEstablished: '2022',
        numStartups: '12',
        sectorFocus: 'ICT',
        targetAudience: 'Early-stage startups',
        targetAudienceOther: 'Women Entrepreneurs, Youth Entrepreneurs, Rural Innovators',
        supportNeeded: 'Funding/Grants, Technology resources, Market access and partnerships, Policy advocacy, Capacity building/training, Networking opportunities',
        supportNeededOther: 'International exposure',
        collaborations: 'Universities, NGOs, Investors',
        collaborationsOther: 'Tech communities',
        challenges: 'Infrastructure (e.g., space, equipment, internet)',
        interestedTraining: 'Yes',
        trainingTopics: 'Corporate Strategy Development, Marketing, Financial Management and Accounting, Human Resource Management, Quality and Productivity improvement, leadership and pitching, STEM skill development',
        interestedEvents: 'Yes',
        eventFocus: 'Tech innovations, Social Impact startups, Health innovations, green innovation',
        supportedByCostech: 'Yes',
        openToPartnerships: 'Yes',
        partnerTypes: 'Government agencies, NGOs, Private Companies, Universities, Investors',
        capacityBuilding: 'Children (Primary and Secondary school students), Youth (VETA, College and University students, Graduates) and Women',
        additionalComments: 'We are looking forward on working together in building vibrant Dodoma Innovation Ecosystem',
        spaceName: 'SmartPark-Innovation and Recreational Park, Dodoma'
      }
    },
    {
      id: 9,
      name: 'Incubators za maji',
      company: 'Manufacturing',
      image: '/assest/img/maji.jpg',
      lat: -2.35,
      lng: 32.0167,
      extra: {
        contactName: "Gaza Efloni Mkwama P.O.BOX 352 NYANG'HWALE GEITA",
        contactEmail: 'gazamkwama71@gmail.com',
        phoneNumber: '0714446940 /0764987750',
        spaceType: 'Incubator',
        spaceTypeOther: 'Ubunifu wa incubator ya kipekee inayo Tumia maji ya  moto kutoto mayai mbalimbali haitumii umeme wala mafuta',
        yearEstablished: '01.01.2023',
        numStartups: '18',
        sectorFocus: 'Manufacturing',
        targetAudience: 'Youth Entrepreneurs',
        targetAudienceOther: 'Kusaidia tatizo la ukosefu wa ajira nchini kwani vijana watajifunza utengenezaji na utumiaji wa hizi incubators na kujipatia kipato',
        supportNeeded: 'Funding/Grants',
        supportNeededOther: 'Uhitaji wa fedha katika kuinua ubunifu huu pia kusajiri umiliki wa ubunifu usiibiwe na nchi jirani',
        collaborations: 'Access to funding (e.g., grants, seed capital, investors)',
        collaborationsOther: 'Fund and more technology',
        challenges: 'Lack of materials in manufacturing',
        interestedTraining: 'Yes',
        trainingTopics: 'Business development',
        interestedEvents: 'Yes',
        eventFocus: 'Tech innovations',
        supportedByCostech: 'No',
        openToPartnerships: 'No',
        partnerTypes: 'Government agencies',
        capacityBuilding: 'Manufacturing',
        additionalComments: 'Use swahili in advertsment',
        spaceName: 'Incubators za maji'
      }
    },
    {
      id: 10,
      name: 'KIBOHUB TANZANIA',
      company: 'ICT',
      image: '/assest/img/makondaaaa.webp',
      lat: -6.7924,
      lng: 39.2083,
      extra: {
        contactName: 'Adamu Mwinyikayoka',
        contactEmail: 'kibohub@gmail.com',
        phoneNumber: '0768825770',
        spaceType: 'Accelerator',
        yearEstablished: '2020',
        numStartups: '30',
        sectorFocus: 'ICT',
        targetAudience: 'Growth-stage startups',
        supportNeeded: 'Funding/Grants',
        collaborations: 'Access to funding (e.g., grants, seed capital, investors)',
        challenges: 'Lack of funds to run programs',
        interestedTraining: 'Yes',
        trainingTopics: 'Business Development, Compliance Issues and Pitching',
        interestedEvents: 'Yes',
        eventFocus: 'Tech Innovations',
        supportedByCostech: 'No',
        openToPartnerships: 'Yes',
        partnerTypes: 'Investors, NGO, Government Agencies',
        capacityBuilding: 'Entrepreneurship & Business Development, Digital Skills & Technology',
        additionalComments: "Commends COSTECH; recommends stronger collaboration, sustainable funding, infrastructure access, and visibility for homegrown innovations.",
        spaceName: 'KIBOHUB TANZANIA'
      }
    },
    {
      id: 12,
      name: 'Shamba Box',
      company: 'Agriculture',
      image: '/assest/img/shox.jpg',
      lat: -6.369028,
      lng: 34.888822,
      extra: {
        contactName: 'Seth Charles Mkisi',
        contactEmail: 'info@shambabox.org',
        phoneNumber: '0756492406',
        spaceType: 'Research & Development Hub',
        yearEstablished: '2019',
        sectorFocus: 'Agriculture',
        targetAudience: 'Youth Entrepreneurs',
        description: "Transforms Tanzania's food systems by supporting farmers and agripreneurs with agribusiness development and innovation.",
        programsOffered: 'Agribusiness development, leadership, pitching, marketing',
        challenges: 'Lack of funds and experts',
        collaborations: 'Access to funding, partnerships with CGIAR',
        supportedByCostech: 'No',
        spaceName: 'Shamba Box'
      }
    },
    {
      id: 13,
      name: 'Taifa Tekk',
      company: 'Education',
      image: '/assest/img/taifa.webp',
      lat: -6.369028,
      lng: 34.888822,
      extra: {
        contactName: 'Said Hozza',
        contactEmail: 'sahozza@tatechhub.com',
        phoneNumber: '0684736765',
        spaceType: 'Maker Space',
        yearEstablished: '2022',
        sectorFocus: 'Education',
        targetAudience: 'Early-stage startups',
        description: 'Maker space focused on education with electronics prototyping and EdTech skills.',
        programsOffered: 'Business planning and sustainable models; Arduino/electronics prototyping',
        challenges: 'Foundational business/technical skill gaps',
        collaborations: 'Policy advocacy and regulatory support, market access and partnerships',
        supportedByCostech: 'No',
        spaceName: 'Tatech Hub'
      }
    },
    {
      id: 14,
      name: 'MEI Centre',
      company: 'Manufacturing',
      image: '/assest/img/irdp.jpg',
      lat: -3.3667,
      lng: 37.3333,
      extra: {
        contactName: 'Winnie Donald',
        contactEmail: 'wdonald@irdp.ac.tz',
        phoneNumber: '0782761872',
        spaceType: 'Incubator',
        yearEstablished: '2020',
        sectorFocus: 'Manufacturing',
        targetAudience: 'Youth Entrepreneurs',
        description: 'IRDP Innovation Hub supports youth entrepreneurs in manufacturing with incubation services.',
        programsOffered: 'Idea pitching, prep of innovation programs, service marketing',
        challenges: 'Fund shortage; lack of MVP facilities; lack of operational manual',
        collaborations: 'Workshops and boot camps',
        supportedByCostech: 'Yes',
        spaceName: 'MIPANGO ENTREPRENEURSHIP AND INNOVATION (MEI) CENTER'
      }
    },
    {
      id: 15,
      name: 'Makonda Renewable Innovation Hub',
      company: 'Agriculture',
      image: '/assest/img/renewable.avif',
      lat: -6.369028,
      lng: 34.888822,
      extra: {
        contactName: 'Emilian John Shija',
        contactEmail: 'Shijaemilian@gmail.com',
        phoneNumber: '0750324942',
        spaceType: 'Maker Space',
        yearEstablished: '2018',
        sectorFocus: 'Agriculture',
        targetAudience: 'Youth Entrepreneurs, Peasants',
        description: 'Supports startups in renewable energy and space technology with satellite data access and mentorship.',
        programsOffered: 'Business development training',
        challenges: 'Poor equipment',
        collaborations: 'Workshops, technical support',
        supportedByCostech: 'Yes',
        spaceName: 'Makonda Renewable Innovation Hub'
      }
    },
    {
      id: 16,
      name: 'Agriedo Hub',
      company: 'Agriculture',
      image: '/assest/img/agried.png',
      lat: -7.778,
      lng: 35.693,
      extra: {
        contactName: 'HADIJA JABIR PHERRI',
        contactEmail: 'agriedoltd@gmail.com',
        phoneNumber: '0756999118',
        spaceType: 'Incubator, Co Working Space',
        yearEstablished: '2023',
        numStartups: '3000',
        sectorFocus: 'Agriculture',
        targetAudience: 'Youth Entrepreneurs, Women Entrepreneurs',
        supportNeeded: 'Infrastructure (space, equipment, internet)',
        supportNeededOther: 'Team, Networking Opportunities and Capacity building',
        collaborations: 'Access to funding (grants, seed capital, investors)',
        collaborationsOther: 'Mentorship Programs, Workshops and Bootcamps',
        challenges: 'Low Sustainability, Misuse of Fund.',
        interestedTraining: 'Yes',
        trainingTopics: 'Agribusiness',
        interestedEvents: 'Yes',
        eventFocus: 'Donors, NGOS, Universities',
        supportedByCostech: 'No',
        openToPartnerships: 'Yes',
        partnerTypes: 'Donors, NGOS, Universities',
        capacityBuilding: 'Yes',
        additionalComments: 'Grassroots agribusiness hub empowering youth and women; seeks impactful partnerships.',
        spaceName: 'Agriedo Hub'
      }
    },
    {
      id: 17,
      name: 'Dodoma (IEC) centre',
      company: 'Technology',
      image: '/assest/img/shamba.jpg',
      lat: -6.1630,
      lng: 35.7516,
      extra: {
        contactName: 'Salum Matotola',
        contactEmail: 'salum.matotola@udom.ac.tz and matotola2015@gmail.com',
        phoneNumber: '+255 767 205266',
        spaceType: 'Accelerator',
        yearEstablished: '2019',
        numStartups: '3',
        sectorFocus: 'Technology',
        targetAudience: 'Early-stage startups',
        supportNeeded: 'Funding/Grants; Infrastructures; Technology resources; Partnerships; Training; Policy advocacy',
        collaborations: 'All listed collaboration areas',
        challenges: 'Infrastructure; Funding; Mentorship; Commercialization',
        interestedTraining: 'Yes',
        trainingTopics: 'Business development, pitching, marketing',
        interestedEvents: 'Yes',
        eventFocus: 'Tech, green innovations, manufacturing, agri- and tech-preneurship',
        supportedByCostech: 'Yes',
        openToPartnerships: 'Yes',
        partnerTypes: 'Investors, universities, NGOs, government agencies',
        capacityBuilding: 'Product development and marketing under HEET Project',
        spaceName: 'The University of Dodoma Innovation and Entrepreneurship Center (IEC)',
        description: 'Promotes skills and platform for UDOM community in innovation and entrepreneurship.'
      }
    },
    {
      id: 18,
      name: 'Gunzert House',
      company: 'Creative Industries',
      image: '/assest/img/gunzert.jpg',
      lat: -2.5164,
      lng: 32.9175,
      extra: {
        contactName: 'Dr Delphine Kessy',
        contactEmail: 'delphinekessy@gmail.com',
        phoneNumber: '0754819590',
        spaceType: 'Incubator',
        yearEstablished: '2022',
        numStartups: '13',
        sectorFocus: 'Creative Industries',
        targetAudience: 'Early-stage startups',
        location: 'Historical building serving as cultural meeting point; sustainable tourism focus.',
        supportNeeded: 'Market access and partnerships',
        collaborations: 'Access to funding (grants, seed capital, investors)',
        challenges: 'Limited market access and visibility; lack of robust artist support systems',
        interestedTraining: 'Yes',
        trainingTopics: 'Cultural entrepreneurship, digital marketing, sustainable tourism, modernizing traditional arts',
        interestedEvents: 'Yes',
        eventFocus: 'Cultural entrepreneurship, sustainable tourism, creative arts innovation',
        supportedByCostech: 'No',
        openToPartnerships: 'Yes',
        spaceName: 'Gunzert House'
      }
    },
    {
      id: 19,
      name: 'Mipango Entrepreneurship and Innovation Center',
      company: 'Manufacturing',
      image: '/assest/img/irdp.jpg',
      lat: -6.1630,
      lng: 35.7516,
      extra: {
        contactName: 'Winnie Donald',
        contactEmail: 'wdonald@irdp.ac.tz',
        phoneNumber: '0782761872',
        spaceType: 'Incubator',
        yearEstablished: '2020',
        numStartups: '5',
        sectorFocus: 'Manufacturing',
        targetAudience: 'Youth Entrepreneurs',
        supportNeeded: 'Funding/Grants',
        supportNeededOther: 'Human resource',
        collaborations: 'Workshops and boot camps',
        challenges: 'Fund shortage; lack of MVP facilities; lack of operational manual',
        interestedTraining: 'Yes',
        trainingTopics: 'Idea pitching; innovation programs; service marketing',
        supportedByCostech: 'Yes',
        openToPartnerships: 'Yes',
        partnerTypes: 'COSTECH, MOEST, UNDP, UNESCO, StartHub Africa, WFP, HLIs, NGOs',
        capacityBuilding: 'Proposal writing for funding/grants',
        additionalComments: 'Advocate university hubs with real plans and budgets',
        spaceName: 'Mipango Entrepreneurship and Innovation Center',
        description: 'Supports youth entrepreneurs in manufacturing within academic settings.'
      }
    },
    {
      id: 20,
      name: 'Jamii Talk',
      company: 'Education',
      image: '/assest/img/jamiitalk.jpg',
      lat: -3.3869,
      lng: 36.6822,
      extra: {
        contactName: 'Emmanuel kasomi',
        contactEmail: 'kasomi@jamiitalk.com',
        phoneNumber: '0767441933',
        spaceType: 'Accelerator, Club',
        yearEstablished: '2022',
        numStartups: '0',
        sectorFocus: 'Education',
        targetAudience: 'Early-stage startups',
        supportNeeded: 'Infrastructure (space, equipment, internet)',
        supportNeededOther: 'Resources to uplift this program',
        collaborations: 'Industry partnerships',
        challenges: 'Lack of funds developing this club',
        interestedTraining: 'Yes',
        trainingTopics: 'Business development, leadership and education',
        interestedEvents: 'Yes',
        eventFocus: 'Edtech',
        supportedByCostech: 'No',
        openToPartnerships: 'Yes',
        partnerTypes: 'Universities and government agencies',
        capacityBuilding: 'Networking',
        spaceName: 'Jamii Talk',
        description: 'Education-focused accelerator/club in Arusha supporting early-stage startups.'
      }
    },
    {
      id: 21,
      name: 'Kiwanda Innovation Center',
      company: 'Education',
      image: '/assest/img/kiwanda.jpg',
      lat: -5.1333,
      lng: 38.7667,
      extra: {
        contactName: 'Moi Mathias Mwakikoti',
        contactEmail: 'moi.mwakikoti@moe.go.tz',
        phoneNumber: '0653554195',
        spaceType: 'Incubator',
        yearEstablished: '2022',
        numStartups: '2',
        sectorFocus: 'Education',
        targetAudience: 'Early-stage startups',
        supportNeeded: 'Infrastructure (space, equipment, internet)',
        supportNeededOther: 'Internet (Dish)',
        collaborations: 'Workshops and boot camps',
        collaborationsOther: 'Training',
        challenges: 'Internet',
        interestedTraining: 'Yes',
        trainingTopics: 'Leadership, business development',
        interestedEvents: 'Yes',
        eventFocus: 'Social impact startups',
        supportedByCostech: 'Yes',
        openToPartnerships: 'Yes',
        partnerTypes: "Universities and NGO's",
        capacityBuilding: 'Leadership modeling',
        additionalComments: 'Society is still away from technology impact',
        spaceName: 'Kiwanda Innovation Center',
        description: 'Supports early-stage startups in education; focuses on leadership, business development, and social impact.'
      }
    },
    {
      id: 2,
      name: 'Wency Tech',
      company: 'Renewable Energy',
      image: '/assest/img/BAM.png',
      lat: -2.5164,
      lng: 32.9175,
      extra: {
        contactName: 'Wenceslaus Frank',
        contactEmail: 'wenceslausfrank@gmail.com',
        phoneNumber: '0620842438',
        spaceType: 'Maker Space',
        yearEstablished: '2025',
        numStartups: '3',
        sectorFocus: 'Renewable Energy',
        targetAudience: 'Early-stage startups',
        supportNeeded: 'Funding/Grants',
        supportNeededOther: 'Funding or Grants but also capacity building and training from successful mentors',
        collaborations: 'Mentorship programs',
        challenges: 'Business plan and prototype reviews and facilitation of workshops and boot camps',
        interestedTraining: 'Yes',
        trainingTopics: 'Marketing',
        interestedEvents: 'Yes',
        eventFocus: 'Green innovations',
        supportedByCostech: 'No',
        openToPartnerships: 'Yes',
        partnerTypes: 'Investors',
        capacityBuilding: 'Business plans and leadership development skills',
        spaceName: 'Wency tech'
      }
    },
    {
      id: 3,
      name: 'Njombe FDC',
      company: 'Education',
      image: '/assest/img/maendeleo.jpg',
      lat: -9.3333,
      lng: 34.7667,
      extra: {
        contactName: 'Adam Rogers',
        contactEmail: 'adam.kasema@moe.go.tz',
        phoneNumber: '0762 018682',
        spaceType: 'Incubator',
        spaceTypeOther: '',
        yearEstablished: '1975',
        numStartups: '3',
        sectorFocus: 'Education',
        targetAudience: 'Early-stage startups',
        targetAudienceOther: '',
        supportNeeded: 'Technology resources (e.g., software, tools)',
        supportNeededOther: 'Machines',
        collaborations: 'Mentorship programs',
        collaborationsOther: '',
        challenges: 'Capacity building and funding',
        interestedTraining: 'Yes',
        trainingTopics: 'Business developing',
        interestedEvents: 'Yes',
        eventFocus: 'Tech innovation',
        supportedByCostech: 'No',
        openToPartnerships: 'Yes',
        partnerTypes: 'Universities and government agencies',
        capacityBuilding: 'How to manage hub effectively',
        additionalComments: 'Support our hubs running cost',
        spaceName: 'Njombe FDC'
      }
    },
    {
      id: 4,
      name: 'SIDO TLED HUB-Mwanza',
      company: 'ICT',
      image: '/assest/img/sido.png',
      lat: -2.5164,
      lng: 32.9175,
      extra: {
        contactName: 'Hassan Juma Ally',
        contactEmail: 'hassanally63@gmail.com',
        phoneNumber: '+255784288101',
        spaceType: 'Incubator',
        spaceTypeOther: 'NIL',
        yearEstablished: '2019',
        numStartups: '18',
        sectorFocus: 'ICT',
        targetAudience: 'Early-stage startups',
        targetAudienceOther: 'N/L',
        supportNeeded: 'Funding/Grants',
        supportNeededOther: 'Capacity building for our staff',
        collaborations: 'Access to funding (e.g., grants, seed capital, investors)',
        collaborationsOther: 'Facilitation of workshops and boot camps',
        challenges: 'Funding',
        interestedTraining: 'Yes',
        trainingTopics: 'Business development',
        interestedEvents: 'Yes',
        eventFocus: 'Tech innovations',
        supportedByCostech: 'Yes',
        openToPartnerships: 'Yes',
        partnerTypes: 'NGOs, government agencies',
        capacityBuilding: 'Incubates',
        additionalComments: 'Some of our incubates has been funded by Costech regarding innovation support funding',
        spaceName: 'SIDO TLED HUB-Mwanza'
      }
    },
    {
      id: 5,
      name: 'CDTI Mlale-innovation centre',
      company: 'ICT',
      image: '/assest/img/mlale.jpg',
      lat: -8.4833,
      lng: 35.6922,
      extra: {
        contactName: 'Mwendo Mnambala',
        contactEmail: 'mwendo.mnambala@jamii.go.tz',
        phoneNumber: '0755428778',
        spaceType: 'Incubator',
        spaceTypeOther: 'N/A',
        yearEstablished: '2019',
        numStartups: '03',
        sectorFocus: 'ICT',
        targetAudience: 'Rural Innovators',
        targetAudienceOther: '',
        supportNeeded: 'Capacity building/training',
        supportNeededOther: 'N/A',
        collaborations: 'Access to funding (e.g., grants, seed capital, investors)',
        collaborationsOther: '',
        challenges: 'Access to funds',
        interestedTraining: 'Yes',
        trainingTopics: 'Pitching',
        interestedEvents: 'Yes',
        eventFocus: '',
        supportedByCostech: 'No',
        openToPartnerships: 'Yes',
        partnerTypes: '',
        capacityBuilding: 'Technology development',
        additionalComments: 'No',
        spaceName: 'CDTI MLALE DIGITAL INNOVATION CENTRE'
      }
    },
    {
      id: 6,
      name: 'JAMII OUTREACH Innovation-Centre',
      company: 'Education',
      image: '/assest/img/outreach.jpg',
      lat: -6.7924,
      lng: 39.2083,
      extra: {
        contactName: 'Alphonce Arone Sikabena',
        contactEmail: 'sikabena.alphonce@gmail.com',
        phoneNumber: '+255755800697',
        spaceType: 'Research & Development Hub',
        spaceTypeOther: 'Digital and Social Innovation Hub',
        yearEstablished: '2019-12-05',
        numStartups: '11',
        sectorFocus: 'Education',
        targetAudience: 'Other',
        targetAudienceOther: 'All the above listed',
        supportNeeded: 'Other',
        supportNeededOther: 'All the above',
        collaborations: 'Other',
        collaborationsOther: 'All the above',
        challenges: 'Limited funding, poor infrastructure, inaccessible internet and communication, poor tech capacity including utilization of Artificial intelligence',
        interestedTraining: 'Yes',
        trainingTopics: 'Entrepreneurship, business development, pitching, marketing, digital literacy, leadership, IP management, ICT, AI',
        interestedEvents: 'Yes',
        eventFocus: 'Social impact startups, tech innovations, green innovations etc',
        supportedByCostech: 'Yes',
        openToPartnerships: 'Yes',
        partnerTypes: 'Investors, International agencies, Government agencies, Embassies, CSOs, Innovation hubs, Universities',
        capacityBuilding: 'Entrepreneurship & Innovation bootcamps, business development, pitching, digital literacy, leadership, IP, ICT, AI',
        spaceName: 'JAMII OUTREACH DIGITAL INNOVATION CENTRE'
      }
    },
    {
      id: 7,
      name: 'Nafasi Talent Space',
      company: 'Creative Industries',
      image: '/assest/img/dtb1.png',
      lat: -3.6667,
      lng: 32.7167,
      extra: {
        contactName: 'Ms Hafswa Hassan',
        contactEmail: 'hafksha@gmail.com',
        phoneNumber: '0743658582',
        spaceType: 'Incubator',
        spaceTypeOther: 'Afro-Centric Creative Talent Incubator',
        yearEstablished: '2025',
        numStartups: '2',
        sectorFocus: 'Creative Industries',
        targetAudience: 'Early-stage startups',
        supportNeeded: 'Funding/Grants',
        supportNeededOther: 'Culturally-Aligned Mentorship & Engagement',
        collaborations: 'Facilitation of workshops and boot camps',
        challenges: 'Limited funding, rural infrastructure gaps, low digital access',
        interestedTraining: 'Yes',
        trainingTopics: "Ethical branding, modest fashion, digital storytelling, entrepreneurship, mental wellness, faith-aligned creative leadership",
        interestedEvents: 'Yes',
        eventFocus: 'Creative industries, digital inclusion, youth innovation',
        supportedByCostech: 'No',
        openToPartnerships: 'Yes',
        partnerTypes: 'Impact investors, universities, NGOs, FBOs, cultural institutions, government agencies',
        capacityBuilding: 'Talent incubation, digital skills, ethical branding, community engagement, entrepreneurship, investor readiness',
        additionalComments: 'Prioritize creative industries in underserved regions like Shinyanga',
        spaceName: 'Nafasi Talent Space'
      }
    },
    {
      id: 8,
      name: 'HORTI-SAVVY SOLUTIONS',
      company: 'Agriculture',
      image: '/assest/img/hortsavy.jpg',
      lat: -9.3333,
      lng: 33.45,
      extra: {
        contactName: 'Erick Liyumba',
        contactEmail: 'erickliyumba1@gmail.com',
        phoneNumber: '0657871647',
        spaceType: 'Incubator',
        spaceTypeOther: 'No',
        yearEstablished: 'Training youth and women groups in avocado and banana farming',
        numStartups: '12',
        sectorFocus: 'Agriculture',
        targetAudience: 'Youth Entrepreneurs',
        targetAudienceOther: 'Women groups',
        supportNeeded: 'Capacity building/training',
        supportNeededOther: 'Grants',
        collaborations: 'Facilitation of workshops and boot camps',
        collaborationsOther: '',
        challenges: 'Skills, equipment and fund',
        interestedTraining: 'Yes',
        trainingTopics: 'Horticulture education, Business Compliance, Export knowledge, entrepreneurship',
        interestedEvents: 'Yes',
        eventFocus: 'Horticulture agribusiness',
        supportedByCostech: 'No',
        openToPartnerships: 'Yes',
        partnerTypes: 'Technology transfer, training, networking, mentorship',
        capacityBuilding: 'Increase production, compliance and export opportunities',
        spaceName: 'HORTI-SAVVY SOLUTIONS'
      }
    },
    {
      id: 22,
      name: 'Ndoto Hub',
      company: 'Entrepreneurship',
      image: '/assest/img/master12.jpg',
      lat: -6.7924,
      lng: 39.2083,
      extra: {
        contactName: 'Iku Lazaroa',
        phoneNumber: '767927927',
        spaceType: 'Innovation Hub',
        spaceName: 'Ndoto Hub',
        description: 'Creates a conducive working and learning environment for aspiring women entrepreneurs in Tanzania.',
        additionalComments: 'Shule Direct Ltd 539 Old Bagamoyo Road P. O. Box 105821'
      }
    },
    {
      id: 23,
      name: 'Bio-Innovation Space',
      company: 'Bio-based Innovation',
      image: '/assest/img/maji.jpg',
      lat: -6.7924,
      lng: 39.2083,
      extra: {
        contactName: 'Japhet Sekenya',
        phoneNumber: '0764-2700768',
        spaceType: 'Incubator / Co-working',
        spaceName: 'Bio-Innovation Space',
        description: 'Supports growth and development of bio-based disciplines and businesses by offering ideation and co-working spaces, trainings, and entrepreneurship support for commercializing bio-products.'
      }
    },
    {
      id: 24,
      name: 'Rlabs Iringa',
      company: 'Community Innovation',
      image: '/assest/img/makondaaaa.webp',
      lat: -7.7780,
      lng: 35.6880,
      extra: {
        contactName: 'Yusuph Ssessanga',
        phoneNumber: '0657-893866',
        spaceType: 'Innovation Lab',
        spaceName: 'Rlabs Iringa',
        description: 'Inspires, enables and supports hope among out-of-school youth, college leavers and rural communities by fostering an alternative mindset that results in innovation.'
      }
    },
    {
      id: 25,
      name: 'Zanzibar Technology and Business Incubator (ZTBI)',
      company: 'Business Incubator',
      image: '/assest/img/shox.jpg',
      lat: -6.1659,
      lng: 39.2026,
      extra: {
        contactName: 'Aisha A Seif',
        phoneNumber: '0772-088898',
        spaceType: 'Incubator',
        spaceName: 'ZTBI',
        description: 'Provides a micro environment for youth businesses and unleashes their growth potential via entrepreneurship training and business development support (BDS).',
        additionalComments: 'Ministry of Labour, Empowerment, Elderly, Women and Children, Zanzibar'
      }
    },
    {
      id: 26,
      name: 'Anza',
      company: 'Entrepreneurship Support',
      image: '/assest/img/taifa.webp',
      lat: -3.3869,
      lng: 37.3333,
      extra: {
        contactName: 'Dina Kikuli',
        phoneNumber: '717964222',
        spaceType: 'Innovation Organization',
        spaceName: 'Anza Hub - Moshi/Arusha',
        description: 'Helps impactful businesses grow to create jobs and deliver life-improving products and services to low income Tanzanians.'
      }
    },
    {
      id: 27,
      name: 'Mushroom Innovation Support Center',
      company: 'Agri-biotech',
      image: '/assest/img/agried.png',
      lat: -6.7924,
      lng: 39.2083,
      extra: {
        contactName: 'Gloria Deogratius Kahumba',
        phoneNumber: '0769-652649',
        spaceType: 'Support Center',
        spaceName: 'Mushroom Innovation Support Center',
        additionalComments: 'TIRDO - P.O. BOX 23235 DSM',
        description: 'Provides technical support to mushroom producers through training, supervision, research and inputs along the value chain.'
      }
    },
    {
      id: 28,
      name: 'SUA Innovation Hub',
      company: 'University Innovation',
      image: '/assest/img/shamba.jpg',
      lat: -6.8235,
      lng: 37.6619,
      extra: {
        contactName: 'Doreen Ndossi',
        phoneNumber: '684847595',
        spaceType: 'Innovation Hub',
        spaceName: 'SUA Innovation Hub Morogoro',
        description: 'Promotes, coordinates and manages innovations across SUA; operates a food processing pilot plant for practical training, incubation and income generation.'
      }
    },
    {
      id: 29,
      name: 'Kiota Innovation Hub',
      company: 'Entrepreneurship',
      image: '/assest/img/gunzert.jpg',
      lat: -7.7780,
      lng: 35.6880,
      extra: {
        contactName: 'Deo Sabokwigina',
        phoneNumber: '0755-399983',
        spaceType: 'Innovation Hub',
        spaceName: 'Kiota Innovation Hub (UoI CEI)',
        additionalComments: 'University of Iringa, Centre for Entrepreneurship and Innovation (CEI)',
        description: 'Open space using multi-disciplinary approaches to nurture business ideas, transform mindsets, network and co-create for economic empowerment.'
      }
    },
    {
      id: 30,
      name: 'AMCET Innovation Hub',
      company: 'Engineering & Technology',
      image: '/assest/img/jamiitalk.jpg',
      lat: -6.7924,
      lng: 39.2083,
      extra: {
        contactName: 'Jannat Sulayman',
        spaceType: 'Innovation Hub',
        spaceName: 'Al-Maktoum College of Engineering and Technology (AMCET)',
        description: 'Aims to be a leading centre for innovation, creativity and technology for youth in Tanzania.'
      }
    },
    {
      id: 31,
      name: 'UDOM Innovation Space and Incubation Centre',
      company: 'University Incubation',
      image: '/assest/img/kiwanda.jpg',
      lat: -6.1730,
      lng: 35.7419,
      extra: {
        contactName: 'Prof. Flora Fabian',
        phoneNumber: '0784-485678',
        spaceType: 'Incubation Centre',
        spaceName: 'UDOM Innovation Space and Incubation Centre',
        additionalComments: 'University of Dodoma; P.O.Box 259, Dodoma',
        description: 'Facilitates and nurtures innovative ideas from students, staff and community; supports startups and MSMEs for job creation and business growth.'
      }
    },
    {
      id: 32,
      name: 'The Jenga Hub',
      company: 'Digital Skills',
      image: '/assest/img/BAM.png',
      lat: -6.7924,
      lng: 39.2083,
      extra: {
        contactName: 'Nancy Sumary',
        phoneNumber: '222761741',
        spaceType: 'Youth Hub',
        spaceName: 'The Neghesti Sumari Foundation',
        description: 'Enables children and youth to become digitally fluent by applying design thinking to ideate, design and create with technology.'
      }
    },
    {
      id: 33,
      name: 'MUST ICT Solutions and Innovation Centre - MIIC',
      company: 'University Innovation',
      image: '/assest/img/maendeleo.jpg',
      lat: -8.9070,
      lng: 33.4560,
      extra: {
        contactName: 'Justin Alipoki Mwakatobe',
        phoneNumber: '0742-396895',
        spaceType: 'Innovation Centre',
        spaceName: 'MUSTE ICT Solutions and Innovation Centre – MIIC',
        additionalComments: 'Mbeya University of Science and Technology (MUST)',
        description: 'Strengthens students and staff to create innovative solutions to societal problems.'
      }
    },
    {
      id: 34,
      name: 'Ennovate Ventures',
      company: 'Technology',
      image: '/assest/img/ennovate.jpeg',
      lat: -6.7924,
      lng: 39.2083,
      extra: {
        contactName: 'Joel Nanauka',
        contactEmail: 'info@ennovatehub.com',
        phoneNumber: '0752817723',
        spaceType: 'Venture Studio and Innovation Hub',
        yearEstablished: '2020',
        sectorFocus: 'Technology, Media, and Education',
        targetAudience: 'Early to growth-stage startups and digital entrepreneurs',
        description: 'A venture studio investing in and building tech-driven startups in East Africa, with a strong focus on innovative business models and scalable impact.',
        programsOffered: 'Startup incubation and acceleration; investment support; mentorship programs',
        challenges: 'Access to follow-on funding and scalable infrastructure',
        collaborations: 'Corporate innovation, ecosystem building, and co-investment partnerships',
        supportedByCostech: 'No',
        spaceName: 'Ennovate Ventures'
      }
    },
    {
      id: 35,
      name: 'Sahara Ventures',
      company: 'Technology',
      image: '/assest/img/sahara.jpeg',
      lat: -6.7924,
      lng: 39.2083,
      extra: {
        contactName: 'Jumanne Mtambalike',
        contactEmail: 'info@saharaventures.com',
        phoneNumber: '0713221946',
        spaceType: 'Innovation and Entrepreneurship Hub',
        yearEstablished: '2016',
        sectorFocus: 'Technology and Entrepreneurship',
        targetAudience: 'Startups, Innovators, and Development Partners',
        description: 'An innovation and entrepreneurship support organization that builds ecosystems through technology, investment, and capacity-building programs.',
        programsOffered: 'Sahara Accelerator; Sahara Sparks Innovation Forum; Capacity-building and investment readiness programs',
        challenges: 'Limited access to local investment capital; scaling impact across regions',
        collaborations: 'Partnerships with international accelerators, corporate innovation programs, and government initiatives',
        supportedByCostech: 'Yes',
        spaceName: 'Sahara Ventures'
      }
    },
    {
      id: 36,
      name: 'Kiota Hub',
      company: 'Social Innovation',
      image: '/assest/img/kiota.jpeg',
      lat: -6.7924,
      lng: 39.2083,
      extra: {
        contactName: 'Catherine Ruge',
        contactEmail: 'info@kiotahub.or.tz',
        phoneNumber: '0620120108',
        spaceType: 'Innovation and Coworking Space',
        yearEstablished: '2019',
        sectorFocus: 'Youth Empowerment and Social Innovation',
        targetAudience: 'Women and youth-led startups and community-based innovators',
        description: 'A creative innovation hub providing workspace, mentorship, and entrepreneurial training for youth and women innovators in Tanzania.',
        programsOffered: 'Women Entrepreneurship Program; Youth Business Clinics; Innovation Challenges',
        challenges: 'Limited funding opportunities for social enterprises',
        collaborations: 'Partnerships with NGOs, government bodies, and donor agencies for youth development',
        supportedByCostech: 'Yes',
        spaceName: 'Kiota Hub'
      }
    },
    {
      id: 37,
      name: 'Smart Lab',
      company: 'Technology',
      image: '/assest/img/smartlab.jpeg',
      lat: -6.7924,
      lng: 39.2083,
      extra: {
        contactName: 'Edwin Bruno',
        contactEmail: 'info@smartlab.co.tz',
        phoneNumber: '0683020890',
        spaceType: 'Corporate Innovation Lab',
        yearEstablished: '2017',
        sectorFocus: 'Media, Technology, and Corporate Innovation',
        targetAudience: 'Startups, Corporates, and Digital Innovators',
        description: 'Smart Lab is an innovation lab connecting startups and corporates to co-create scalable solutions through digital transformation and innovation programs.',
        programsOffered: 'Smart Accelerator; Corporate Open Innovation Programs; Product Design and Development Support',
        challenges: 'Sustainability of innovation programs and startup scaling post-acceleration',
        collaborations: 'Corporate partnerships, development organizations, and innovation ecosystem players',
        supportedByCostech: 'Yes',
        spaceName: 'Smart Lab'
      }
    },
    {
      id: 38,
      name: 'ReFocus Afrika Hub',
      company: 'Multi-sector',
      description: 'Technology and innovation hub supporting startup incubation, research commercialization, and regional entrepreneurship in Mbeya.',
      image: '/assest/img/maji.jpg',
      lat: -8.9055,
      lng: 33.4585,
      extra: {
        spaceName: 'ReFocus Afrika Technology & Innovation Hub, Mbeya',
        sectorFocus: 'Multi-sector—Agriculture and Agribusiness; Mining and Mineral Value Addition; Solar and Renewable Energy; Housing and Construction Technologies; Transportation and Logistics; Media, Entertainment and Creative Industries',
        spaceType: 'Technology and Innovation Hub; Startup Incubator and Accelerator',
        description: 'Future Skills Academy; startup incubation and acceleration; entrepreneurship and business development; research commercialization; technology transfer; investment facilitation; workforce development; innovation challenges; mentorship; product-development support; market access; investor readiness; venture scaling and export readiness',
        programsOffered: 'Future Skills Academy; startup incubation and acceleration; entrepreneurship and business development; research commercialization; technology transfer; investment facilitation; workforce development; innovation challenges; mentorship; product-development support; market access; investor readiness; venture scaling and export readiness',
        capacityBuilding: 'Youth, innovators, entrepreneurs, startups, SMEs, students, professionals, researchers and underserved regional communities',
        yearEstablished: '2026',
        targetAudience: 'Youth entrepreneurs, innovators, startups, SMEs, students, graduates, professionals and researchers',
        supportNeeded: 'Institutional recognition and ecosystem partnerships',
        collaborations: 'Government agencies, COSTECH, universities, research institutions, technology companies, industry associations, investors, development partners, international training providers, diplomatic missions and diaspora professionals',
        collaborationsOther: 'Technology-transfer partnerships; research and industry linkages; international markets and commercialization support',
        interestedTraining: 'No',
        trainingTopics: 'Artificial intelligence, data analytics, drone technology, GIS and remote sensing, software development, digital marketing, entrepreneurship, business development, investor readiness, product development, technology commercialization and intellectual-property management',
        interestedEvents: 'Yes',
        eventFocus: 'Technology and sector-based innovation challenges; startup showcases; investment forums; research-commercialization events; entrepreneurship programmes; and youth innovation activities',
        openToPartnerships: 'Yes',
        partnerTypes: 'Government agencies, research and educational institutions, private-sector companies, investors, development partners, industry associations and international technology and training organizations',
        contactName: 'Dr. Sunshine Silas',
        contactEmail: 'drsunshine@refocusafrika.com',
        phoneNumber: '+255 745 754 316',
        address: 'Plot #111, Ilomba Road, Off VETA Road, Mbeya, Tanzania. P.O. Box 2476, Dar es Salaam',
        website: 'www.refocusafrika.com',
        location: 'Mbeya, Tanzania'
      }
    }
  ]);
  const [showMoreId, setShowMoreId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(1);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const cardRefs = useRef({});

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Set initial state
    handleResize();
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const CARDS_PER_PAGE = 16;

  // Function to navigate to a specific card
  const navigateToCard = useCallback((founderId) => {
    console.log('navigateToCard called with founderId:', founderId);
    
    // First, clear any search to ensure the founder is visible
    setSearchQuery('');
    
    // Find which page contains this founder in the filtered results
    const founderIndex = founders.findIndex(f => f.id === founderId);
    console.log('Founder index:', founderIndex);
    if (founderIndex === -1) {
      console.log('Founder not found in founders array');
      return;
    }
    
    const targetPage = Math.ceil((founderIndex + 1) / CARDS_PER_PAGE);
    
    // Navigate to the correct page
    setPage(targetPage);
    
    // Scroll to the card after a longer delay to allow page change and re-render
    setTimeout(() => {
      console.log('Looking for card element with ID:', founderId);
      console.log('Available card refs:', Object.keys(cardRefs.current));
      const cardElement = cardRefs.current[founderId];
      console.log('Card element found:', cardElement);
      if (cardElement) {
        // Scroll the card into view
        cardElement.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center',
          inline: 'center'
        });
        
        // Add a highlight effect
        cardElement.style.transform = 'scale(1.05)';
        cardElement.style.boxShadow = '0 8px 32px rgba(255, 99, 71, 0.3)';
        cardElement.style.transition = 'all 0.3s ease';
        
        setTimeout(() => {
          cardElement.style.transform = 'scale(1)';
          cardElement.style.boxShadow = '0 4px 24px rgba(0,0,0,0.08)';
        }, 2000);
      } else {
        // If card not found, try again after a longer delay
        setTimeout(() => {
          const retryCardElement = cardRefs.current[founderId];
          if (retryCardElement) {
            retryCardElement.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'center',
              inline: 'center'
            });
            
            retryCardElement.style.transform = 'scale(1.05)';
            retryCardElement.style.boxShadow = '0 8px 32px rgba(255, 99, 71, 0.3)';
            retryCardElement.style.transition = 'all 0.3s ease';
            
            setTimeout(() => {
              retryCardElement.style.transform = 'scale(1)';
              retryCardElement.style.boxShadow = '0 4px 24px rgba(0,0,0,0.08)';
            }, 2000);
          }
        }, 500);
      }
    }, 200);
  }, [founders, CARDS_PER_PAGE]);

  // Auto-scroll functionality
  React.useEffect(() => {
    const scrollContainer = document.querySelector('.space-grid');
    if (!scrollContainer) return;

    let scrollPosition = 0;
    const scrollSpeed = 1; // pixels per frame
    const scrollInterval = 50; // milliseconds between scrolls

    const autoScroll = () => {
      if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth - scrollContainer.clientWidth) {
        // Reset to beginning when reaching the end
        scrollPosition = 0;
        scrollContainer.scrollLeft = 0;
      } else {
        scrollPosition += scrollSpeed;
        scrollContainer.scrollLeft = scrollPosition;
      }
    };

    const intervalId = setInterval(autoScroll, scrollInterval);

    return () => clearInterval(intervalId);
  }, []);

  const getFilteredFounders = () => {
    let filtered = founders;
    if (searchQuery.trim()) {
      const q = searchQuery.trim().toLowerCase();
      filtered = filtered.filter(f =>
        (f.name && f.name.toLowerCase().includes(q)) ||
        (f.company && f.company.toLowerCase().includes(q))
      );
    }
    return filtered;
  };

  const filteredFounders = getFilteredFounders();
  const totalPages = Math.ceil(filteredFounders.length / CARDS_PER_PAGE);
  const paginatedFounders = filteredFounders.slice((page - 1) * CARDS_PER_PAGE, page * CARDS_PER_PAGE);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
  };

  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };

  return (
    <section className="space-section">
      {/* Mobile-specific styles */}
      <style>
        {isMobile && `
          .space-grid::-webkit-scrollbar {
            display: none;
          }
          .space-grid {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
        `}
      </style>
      <div style={{
        width: '100%',
        height: isMobile ? '250px' : '300px',
        background: `url('/assest/img/Hero.jpg') center/cover no-repeat`,
        position: 'relative',
        borderRadius: isMobile ? '10px' : '15px',
        marginBottom: isMobile ? '1.5rem' : '2rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(135deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.3) 100%)',
          zIndex: 1,
        }} />
        <div style={{
          position: 'relative',
          zIndex: 2,
          textAlign: 'center',
          color: 'white',
        }}>
          <h1 style={{
            fontSize: isMobile ? '2.2rem' : '3.2rem',
            fontWeight: 800,
            margin: '0 0 16px 0',
            letterSpacing: isMobile ? 1 : 2,
            textShadow: '0 4px 8px rgba(0,0,0,0.5)',
            padding: isMobile ? '0 1rem' : '0',
          }}>
            Innovation Spaces
          </h1>
          <div style={{ marginTop: '20px' }}>
            <a 
              href="https://forms.gle/hUpK5ueXcexATKpK6" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                background: '#FFD700',
                color: '#333',
                padding: isMobile ? '10px 20px' : '12px 24px',
                borderRadius: '25px',
                textDecoration: 'none',
                fontWeight: 600,
                fontSize: isMobile ? '14px' : '16px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                border: 'none',
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 16px rgba(0,0,0,0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
              }}
            >
              Register to the database 
            </a>
          </div>
        </div>
      </div>

      <div style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? '1rem' : '2rem',
        marginBottom: isMobile ? '1.5rem' : '2rem',
        padding: isMobile ? '0 0.5rem' : '0 1rem',
      }}>
        <div style={{
          flex: '1',
          background: '#FF6347',
          padding: isMobile ? '0.8rem' : '1rem',
          borderRadius: '10px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
          height: isMobile ? 'auto' : '400px',
          minHeight: isMobile ? '300px' : '400px',
          overflow: 'auto',
        }}>
          <h2 style={{
            color: 'white',
            fontSize: isMobile ? '1.2rem' : '1.5rem',
            marginBottom: '1rem',
            fontWeight: 600,
          }}>Welcome to the Tanzania Innovation Spaces Page</h2>
          <p style={{
            color: 'white',
            lineHeight: 1.6,
            marginBottom: '0',
          }}>
            Under its national mandate to foster and coordinate Tanzania’s innovation ecosystem, 
            the Tanzania Commission for Science and Technology (COSTECH) is actively advancing 
            support for innovation spaces nationwide. Under guardianship of the Ministry of 
            Education, Science and Technology (MoEST), COSTECH has introduced two key 
            instruments: the National Guideline for Innovation Spaces an
            d a Standardized Curriculum for Innovation Space Managers. 
            These resources aim to promote effective coordination, operational 
            sustainability, and high-impact programming across the country’s 
            innovation landscape.
            <br /><br />
            This platform serves as a central hub where you can explore and connect with registered 
            innovation spaces across the country. The page provides updated profiles, bios, and 
            contact details of each space. Many of these spaces have received support from COSTECH 
            in the form of mentorship, funding, or technical assistance, while others collaborate 
            closely with the Commission to implement innovation driven initiatives.
            <br /><br />
            By sharing this information, COSTECH aims to increase visibility, foster collaboration, 
            and encourage meaningful partnerships among innovation stakeholders.
            <br /><br />
            We invite you to browse, connect, and partner with these spaces to 
            collectively drive innovation and inclusive development in Tanzania. 
            The list of spaces will be updated regularly to reflect the continued 
            growth of the ecosystem.
          </p>
        </div>

        <div style={{
          flex: '1',
          background: '#FF6347',
          padding: isMobile ? '0.8rem' : '1rem',
          borderRadius: '10px',
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
          height: isMobile ? '350px' : '400px',
          overflow: 'hidden',
        }}>
          <MapWithOpenLayers founders={founders} onMarkerClick={navigateToCard} />
        </div>
      </div>

      <div className="space-container" style={{ padding: isMobile ? '0 5px' : '0 10px' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: isMobile ? 'center' : 'flex-end', 
          marginBottom: isMobile ? 16 : 24, 
          gap: 12 
        }}>
          <form onSubmit={handleSearch} style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 8,
            flexDirection: isMobile ? 'column' : 'row',
            width: isMobile ? '100%' : 'auto'
          }}>
            <input
              type="text"
              placeholder="Search by name or company..."
              value={searchQuery}
              onChange={handleSearchInputChange}
              style={{ 
                padding: '0.5rem 1rem', 
                borderRadius: 5, 
                border: '1px solid #eee', 
                fontSize: isMobile ? 14 : 16,
                width: isMobile ? '100%' : 'auto',
                maxWidth: isMobile ? '300px' : 'none'
              }}
            />
            <button type="submit" style={{ 
              padding: '0.5rem 1.2rem', 
              background: '#eee', 
              color: '#FF6347', 
              border: 'none', 
              borderRadius: '5px', 
              fontWeight: 600, 
              cursor: 'pointer',
              fontSize: isMobile ? 14 : 16,
              width: isMobile ? '100%' : 'auto',
              maxWidth: isMobile ? '300px' : 'none'
            }}>Search</button>
          </form>
        </div>
        <div
          className="space-grid"
          style={{
            display: 'flex',
            gap: isMobile ? '15px' : '20px',
            width: '100%',
            padding: isMobile ? '0 2px' : '0 5px',
            maxWidth: '100%',
            margin: '0 auto',
            overflowX: 'auto',
            scrollBehavior: 'smooth',
            position: 'relative',
            // Mobile-specific optimizations
            WebkitOverflowScrolling: isMobile ? 'touch' : 'auto',
            scrollbarWidth: isMobile ? 'none' : 'auto',
            msOverflowStyle: isMobile ? 'none' : 'auto'
          }}
        >
          {paginatedFounders.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#FF6347', fontWeight: 600, fontSize: 20, padding: '2rem 0', width: '100%' }}>
              No results found for your search/filter. Please try a different name or company.
            </div>
          ) : (
            paginatedFounders.map(founder => (
              <div 
                key={founder.id} 
                ref={el => cardRefs.current[founder.id] = el}
                style={{ 
                  flexShrink: 0, 
                  width: isMobile ? '280px' : '300px' 
                }}
              >
                <SingleCard
                  id={founder.id}
                  image={founder.image}
                  name={founder.name}
                  role={founder.role}
                  company={founder.company}
                  sector={founder.extra?.sectorFocus || founder.sectorFocus}
                  location={founder.extra?.location || founder.sensitiveData?.location}
                  onMore={() => setShowMoreId(founder.id)}
                  extra={founder.extra}
                  isMobile={isMobile}
                />
              </div>
            ))
          )}
        </div>
        

        {totalPages > 1 && (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            margin: isMobile ? '1.5rem auto 1rem auto' : '2rem auto 1rem auto', 
            gap: isMobile ? 6 : 8, 
            flexWrap: 'wrap', 
            maxWidth: '1200px', 
            padding: isMobile ? '0 20px' : '0 40px' 
          }}>
            {/* Simple page numbers - just show all pages */}
            {Array.from({ length: totalPages }, (_, i) => {
              const pageNum = i + 1;
              return (
                <button
                  key={pageNum}
                  onClick={() => setPage(pageNum)}
                  style={{ 
                    padding: isMobile ? '0.4rem 0.6rem' : '0.5rem 0.8rem', 
                    background: pageNum === page ? '#FF6347' : '#f0f0f0', 
                    color: pageNum === page ? 'white' : '#333', 
                    border: 'none', 
                    borderRadius: '5px', 
                    fontWeight: 600, 
                    cursor: 'pointer',
                    fontSize: isMobile ? '12px' : '14px',
                    minWidth: isMobile ? '35px' : '40px'
                  }}
                >
                  {pageNum}
                </button>
              );
            })}
          </div>
        )}

        {showMoreId && (
          <Modal onClose={() => setShowMoreId(null)}>
            <SpaceDetails founder={founders.find(f => f.id === showMoreId)} />
          </Modal>
        )}
      </div>
    </section>
  );
};

const Modal = ({ children, onClose }) => (
  <div style={{
    position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.35)', zIndex: 1000,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  }} onClick={onClose}>
    <div style={{
      background: '#ffffff',
      borderRadius: 18,
      padding: 0,
      minWidth: 340,
      maxWidth: 520,
      width: '90%',
      maxHeight: '90vh',
      overflowY: 'auto',
      position: 'relative',
      boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
      border: '1.5px solid #f3f3f3',
      animation: 'popIn 0.18s cubic-bezier(.4,2,.6,1)'
    }} onClick={e => e.stopPropagation()}>
      <div style={{
        background: 'linear-gradient(90deg, #FF6347 0%, #FF9472 100%)',
        borderRadius: '18px 18px 0 0',
        padding: '1.2rem 2rem 1rem 2rem',
        color: 'white',
        fontWeight: 700,
        fontSize: 22,
        letterSpacing: 0.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        Space Details
        <button onClick={onClose} aria-label="Close" style={{ background: 'none', border: 'none', fontSize: 26, color: 'white', cursor: 'pointer', marginLeft: 12, fontWeight: 700, lineHeight: 1 }}>&times;</button>
      </div>
      <div style={{ padding: '2rem 2rem 1.5rem 2rem' }}>
        {children}
      </div>
    </div>
    <style>{`
      @keyframes popIn {
        0% { transform: scale(0.95); opacity: 0.5; }
        100% { transform: scale(1); opacity: 1; }
      }
    `}</style>
  </div>
);

const SpaceDetails = ({ founder }) => {
  const [showContact, setShowContact] = useState(false);
  if (!founder) return null;
  const extra = founder.extra || {};

  // Function to check if a field has meaningful content
  const hasContent = (value) => {
    return value && value.toString().trim() !== '' && value.toString().trim() !== 'N/A' && value.toString().trim() !== 'NIL' && value.toString().trim() !== 'No';
  };

  // Function to get field value with fallback
  const getFieldValue = (value, fallback = null) => {
    return hasContent(value) ? value : fallback;
  };

  // Define fields to display with their labels and values
  const fields = [
    { label: 'Space Name', value: extra.spaceName || founder.name, alwaysShow: true },
    { label: 'Sector', value: extra.sectorFocus || founder.company, alwaysShow: true },
    { label: 'Type of Space', value: extra.spaceType, alwaysShow: true },
    { label: 'Description / Programs', value: extra.description || extra.programsOffered || extra.collaborationsOther || extra.collaborations, fallback: 'Business plan and prototype reviews, Startup competitions and pitch events, Facilitation of workshops and boot camps' },
    { label: 'Beneficiaries', value: extra.capacityBuilding, fallback: 'Youth entrepreneurs, early-stage startups, and innovators' },
    { label: 'Year Established', value: extra.yearEstablished },
    { label: 'Target Audience', value: extra.targetAudience },
    { label: 'Support Needed', value: extra.supportNeededOther ? (extra.supportNeeded + ' (' + extra.supportNeededOther + ')') : extra.supportNeeded },
    { label: 'Collaborations', value: extra.collaborations },
    { label: 'Collaborations Other', value: extra.collaborationsOther },
    { label: 'Main Challenges', value: extra.challenges },
    { label: 'Interested in Training', value: extra.interestedTraining },
    { label: 'Area of Capacity Building', value: extra.trainingTopics },
    { label: 'Interested in Events', value: extra.interestedEvents },
    { label: 'Event Focus', value: extra.eventFocus },
    { label: 'Open to Partnerships', value: extra.openToPartnerships },
    { label: 'Partnerships Types', value: extra.partnerTypes }
  ];

  // Filter fields to only show those with content or are always shown
  const displayFields = fields.filter(field => field.alwaysShow || hasContent(field.value));

  return (
    <div>
      <h2 style={{ marginTop: 0, color: '#333333', fontWeight: 700, fontSize: 20, marginBottom: 18, textAlign: 'left' }}>{extra.spaceName || founder.name}</h2>
      <ul style={{ paddingLeft: 0, listStyle: 'none', color: '#333333', fontSize: 15, margin: 0, textAlign: 'left' }}>
        {displayFields.map((field, index) => (
          <li key={index} style={liStyle}>
            <strong>{field.label}:</strong> {getFieldValue(field.value, field.fallback)}
          </li>
        ))}
      </ul>
      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <button 
          onClick={() => setShowContact(!showContact)}
          style={{
            padding: '10px 20px',
            background: '#FF6347',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontWeight: 600,
            fontSize: '15px',
            transition: 'background 0.2s'
          }}
          onMouseOver={(e) => e.target.style.background = '#ff4f2f'}
          onMouseOut={(e) => e.target.style.background = '#FF6347'}
        >
          {showContact ? 'Hide Contact Details' : 'Show Contact Details'}
        </button>
        {showContact && (
          <div style={{
            marginTop: '15px',
            padding: '15px',
            background: '#FF6347',
            borderRadius: '8px',
            border: '1px solid #eee',
            textAlign: 'left'
          }}>
            <h3 style={{ color: 'white', marginBottom: '10px', fontSize: '16px' }}>Contact Information</h3>
            {hasContent(extra.contactName) && (
              <p style={{ margin: '5px 0', color: 'white' }}><strong>Contact Person:</strong> {extra.contactName}</p>
            )}
            {hasContent(extra.contactEmail) && (
              <p style={{ margin: '5px 0', color: 'white' }}><strong>Email:</strong> {extra.contactEmail}</p>
            )}
            {hasContent(extra.phoneNumber) && (
              <p style={{ margin: '5px 0', color: 'white' }}><strong>Phone:</strong> {extra.phoneNumber}</p>
            )}
            {hasContent(extra.address) && (
              <p style={{ margin: '5px 0', color: 'white' }}><strong>Address:</strong> {extra.address}</p>
            )}
            {hasContent(extra.website) && (
              <p style={{ margin: '5px 0', color: 'white' }}>
                <strong>Website:</strong>{' '}
                <a
                  href={extra.website.startsWith('http') ? extra.website : `https://${extra.website}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'white', textDecoration: 'underline' }}
                >
                  {extra.website}
                </a>
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const liStyle = {
  marginBottom: 10,
  padding: '7px 0',
  borderBottom: '1px solid #e0e0e0',
  lineHeight: 1.6,
};

export default Space;

// Hide scrollbar completely
const hideScrollbarStyles = `
  .space-grid::-webkit-scrollbar {
    display: none;
  }
  
  .space-grid {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = hideScrollbarStyles;
  document.head.appendChild(styleElement);
}
